import { Reducer, Action } from 'redux'
import { IReloadsState } from 'types/reloads'
import { NEARBY_LOADS_ACTION_TYPES, RELOADS_ACTION_TYPES } from '../actions/reloads'

const {
  NEARBY_LOADS_FAILURE,
  NEARBY_LOADS_REQUEST,
  NEARBY_LOADS_SUCCESS,
} = NEARBY_LOADS_ACTION_TYPES

const { RELOADS_FAILURE, RELOADS_REQUEST, RELOADS_SUCCESS } = RELOADS_ACTION_TYPES

interface ReloadsRequestAction extends Action<string> {
  payload: {
    requestData: {
      id: number
    }
  }
}

interface ReloadsSuccessAction extends Action<string> {
  payload: {
    shipments: { id: number }[]
    radius: number
  }
}

interface ReloadsFailureAction extends Action<string> {
  error: string
}

type ReloadsReducerAction =
  | Action<string>
  | ReloadsRequestAction
  | ReloadsSuccessAction
  | ReloadsFailureAction

const defaultState = {
  loads: {
    fetching: false,
    ids: [],
    radius: 50,
  },
  reloads: {
    fetching: false,
    ids: [],
    radius: 50,
  },
}

const shipmentReducer: Reducer<IReloadsState, ReloadsReducerAction> = (
  state = defaultState,
  action
) => {
  if (!action) return state

  switch (action.type) {
    case NEARBY_LOADS_REQUEST: {
      return {
        ...state,
        loads: {
          ...state.loads,
          shipmentId: (action as ReloadsRequestAction).payload.requestData.id,
          ids: [],
          fetching: true,
        },
      }
    }

    case NEARBY_LOADS_SUCCESS: {
      const { payload } = action as ReloadsSuccessAction
      return {
        ...state,
        loads: {
          ...state.loads,
          ids: payload.shipments.map(({ id }) => id),
          radius: payload.radius || 0,
          fetching: false,
          error: undefined,
        },
      }
    }

    case NEARBY_LOADS_FAILURE: {
      return {
        ...state,
        loads: {
          ...state.loads,
          fetching: false,
          error: (action as ReloadsFailureAction).error,
        },
      }
    }

    case RELOADS_REQUEST: {
      return {
        ...state,
        reloads: {
          ...state.reloads,
          shipmentId: (action as ReloadsRequestAction).payload.requestData.id,
          ids: [],
          fetching: true,
        },
      }
    }

    case RELOADS_SUCCESS: {
      const { payload } = action as ReloadsSuccessAction
      return {
        ...state,
        reloads: {
          ...state.reloads,
          ids: payload.shipments.map(({ id }) => id),
          radius: payload.radius || 0,
          fetching: false,
          error: undefined,
        },
      }
    }

    case RELOADS_FAILURE: {
      return {
        ...state,
        reloads: {
          ...state.reloads,
          fetching: false,
          error: (action as ReloadsFailureAction).error,
        },
      }
    }

    default:
      return state
  }
}

export default shipmentReducer
